"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));

var Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));

var List_1 = __importDefault(require("@material-ui/core/List"));

var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));

var clsx_1 = __importDefault(require("clsx"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var InfoCard_1 = __importDefault(require("../InfoCard"));

var useStyles_1 = __importDefault(require("./useStyles"));

require("./style.scss");
/**
* `SideBar` for the `MapMoment` to provide location information.
  */


var MapSideBar = function MapSideBar(_a) {
  var _b;

  var children = _a.children,
      data = _a.data,
      onSelect = _a.onSelect,
      open = _a.open,
      selectedIndex = _a.selectedIndex;
  var classes = (0, useStyles_1.default)();

  var locationKey = function locationKey(label, index) {
    return label + "-" + index;
  };

  return react_1.default.createElement("div", {
    className: classes.root
  }, react_1.default.createElement(CssBaseline_1.default, null), react_1.default.createElement("main", {
    className: (0, clsx_1.default)(classes.content, (_b = {}, _b[classes.contentShift] = open, _b))
  }, children), react_1.default.createElement(Drawer_1.default, {
    anchor: "right",
    classes: {
      paper: classes.drawerPaper
    },
    className: classes.drawer,
    open: open,
    variant: "persistent"
  }, react_1.default.createElement(List_1.default, null, data.map(function (location, index) {
    return react_1.default.createElement(ListItem_1.default, {
      button: true,
      divider: true,
      key: locationKey(location.label, index),
      onClick: function onClick() {
        return onSelect(index);
      }
    }, react_1.default.createElement(InfoCard_1.default, {
      active: selectedIndex === index,
      data: location
    }));
  }))));
};

MapSideBar.propTypes = {
  /** Information to render for each `MapPin` */
  data: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,

  /** Callback function for when an item is clicked on */
  onSelect: prop_types_1.default.func.isRequired,

  /** Determines if the `SideBar` is visible. */
  open: prop_types_1.default.bool.isRequired,

  /** Current location to expand its contents */
  selectedIndex: prop_types_1.default.number
};
MapSideBar.defaultProps = {
  selectedIndex: undefined
};
exports.default = MapSideBar;